<template>
  <div>
    <Fieldset :legend="$t('searchHeader')" :toggleable="true">
      <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2">
        <div class="p-formgrid p-grid ">
          <div class="p-field p-col-12 p-lg-6 p-mt-2">
            <label for="dataTypeOptions">ประเภทข้อมูล</label>
            <Dropdown
              v-model="dataTypeSelect"
              :options="dataTypeOptions"
              optionLabel="name"
              :filter="true"
              :placeholder="$t('placeholderSelectBox')"
              :showClear="true"
              :clearFilterDropdown="dropdownClearFilerValue"
            >
              <template #value="dataTypeOptions">
                <div v-if="dataTypeOptions.value">
                  <div>{{ dataTypeOptions.value.name }}</div>
                </div>
                <span v-else>
                  {{ dataTypeOptions.placeholder }}
                </span>
              </template>
              <template #option="dataTypeOptions">
                <div>{{ dataTypeOptions.option.name }}</div>
              </template>
            </Dropdown>
          </div>
          <div class="p-field p-col-8 p-lg-3 p-mt-2 p-mr-2">
            <label for="iie_organize">{{ $t("response_agency") }}</label>
            <InputText
              id="iie_organize"
              type="text"
              v-model="selectedOrganize.name"
              disabled
            />
          </div>
          <div class="p-field p-col-3 p-lg-1 p-mt-2 " style=";margin-top: 3.5px !important;">
            <div class="p-formgrid p-grid " >
              <Button
                
                @click="showOrganize = true"
                icon="pi pi-ellipsis-h"
                class="p-button-secondary p-mt-5 p-mr-2"
              />
              <Button
                @click="selectedOrganize = {}"
                icon="pi pi-times"
                class="p-button-danger p-mt-5"
              />
            </div>
          </div>
        </div>
        
          <div class="p-field p-col">
            <div class="p-formgrid p-grid p-jc-end p-mt-5">
              <Button
                @click="clearSearchField()"
                :label="$t('clearBtn')"
                class="p-button-clear p-ml-3 p-mr-3"
              />
              <Button
                @click="searchUpdateInfo()"
                :label="$t('searchBtn')"
                class="p-button-info"
              />
            </div>
          </div>
      </div>
    </Fieldset>

    <div class="card p-fluid p-mt-2">
      <DataTable
        :value="update_table"
        :paginator="true"
        :rows="10"
        dataKey="id"
        :rowHover="true"
        :filters="filters"
        :loading="loading"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 20, 50]"
        currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
      >
        <template #header>
          <div class="table-header p-col-12 p-lg-4" style="margin-left: auto; " >
            <span class="p-input-icon-left">
              <i class="pi pi-search" /><InputText
                v-model="filters['global']"
                :placeholder="$t('searchHeader')"
              />
            </span>
          </div>
        </template>
        <template #empty>{{ $t("TableEmpty") }}</template>
        <Column field="type" header="ประเภทข้อมูล" :sortable="true">
          <template #body="dataTable">
            {{ dataTable.data.type }}
          </template>
        </Column>
        <Column
          field="organize_name"
          :header="$t('response_agency')"
          :sortable="true"
        >
          <template #body="dataTable">
            {{ dataTable.data.organize_name }}
          </template>
        </Column>
        <Column field="count" header="จำนวน (รายการ)" :sortable="true"
        :headerStyle="{textAlign:'center'}">
          <template #body="dataTable">
            <div class="table_row">
              {{ dataTable.data.count }}
            </div>
            
          </template>
        </Column>
      </DataTable>
    </div>

    <Dialog
      :modal="true"
      :header="$t('OrganizeModalHeader')"
      :visible.sync="showOrganize"
      :style="{ width: '80%' }"
      :contentStyle="{ 'overflow-y': 'scroll' }"
    >
      <organize-table
        @selectOrganization="selectedOrganize_passValue"
      ></organize-table>
    </Dialog>
  </div>
</template>

<script>
import organizeTable from "./OrganizeTable";

export default {
  components: {
    organizeTable,
  },
  data() {
    return {
      dropdownClearFilerValue:0,
      dataTypeOptions: [
        { id: "getall", name: "เลือกทั้งหมด" },
        { id: "man", name: "ข้อมูลกำลังคน" },
        { id: "equip", name: "ข้อมูลเครื่องมือฯ" },
      ],
      dataTypeSelect: { id: "getall", name: "เลือกทั้งหมด" },
      selectedOrganize: {},
      update_table: [],
      showOrganize: false,

      filters: {},
      loading:false,
    };
  },
  watch: {},
  created() {
    this.initialData();
  },

  methods: {
    async initialData() {
      this.loading = true;
      this.filters={}
      await this.axios
        .post(`${this.$url_service}/get/update-info`, {
          body: {
            topic: "get-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
          },
        })
        .then((response) => (this.update_table = response.data.data));
        this.loading = false;
    },

    async searchUpdateInfo() {
      this.filters={}
      this.loading = true;
      await this.axios
        .post(`${this.$url_service}/get/update-info`, {
          body: {
            topic: "search-table",
            userOrg: this.checkPermission() ? null : this.getUserOrganize(),
            // type: this.dataTypeSelect.id ,
            type: this.dataTypeSelect == null ? "getall"  : this.dataTypeSelect.id ,
            organize: this.selectedOrganize.id,
          },
        })
        .then((response) => (this.update_table = response.data.data));
        this.loading = false;
    },

    selectedOrganize_passValue(variable) {
      this.showOrganize = false;
      this.selectedOrganize = {
        id: variable.organize_id,
        name: variable.organize_name,
      };
    },

    async clearSearchField() {
      this.dropdownClearFilerValue +=1;
      this.filters={}
      this.dataTypeSelect = { id: "getall", name: "เลือกทั้งหมด" };
      this.selectedOrganize = {};
      this.initialData();
    },
  },
};
</script>

<style scoped>
.table_row{
  text-align: center;
}
.p-field {
  margin-bottom: 0rem;
}
</style>

<style>
.p-datatable-thead {
  border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
  border: 2px solid #d6d6d6;
}
</style>
